import { MessageSeverity, UiMessageProps } from "../../models/components/field-message.model";
import { useAppointmentsTypes } from "../../hooks/useAppointmentsTypes";
import { useAppointmentsUpcoming } from "../../hooks/useAppointmentsUpcoming";
import UiMessage from "../../components/message/Message.component";
import { useTranslation } from "react-i18next";
import { AppointmentsService } from "../../services/appointments/appointments.service";

const UpcomingAppointments = () => {
	const { t } = useTranslation("common");

	const apptsTypesQuery = useAppointmentsTypes();
	const apptsUpcomingQuery = useAppointmentsUpcoming();

	const hasData = () => {
		let result = false;
		if (
			apptsUpcomingQuery.data &&
			apptsUpcomingQuery.data?.filter(
				(x) => new Date(x.datetime).getTime() >= new Date().getTime()
			).length > 0
		) {
			result = true;
		}
		return result;
	};

	const setMessage = () => {
		let result: UiMessageProps = {
			severity: MessageSeverity.LOADING,
			label: "UI_COMPONENTS.MESSAGE.MSG.LOADING",
		};
		if (apptsUpcomingQuery.isError) {
			result = {
				severity: MessageSeverity.DANGER,
				label: "UI_COMPONENTS.MESSAGE.MSG.ERROR",
			};
		} else if (!apptsUpcomingQuery.isLoading && !apptsUpcomingQuery.isError && !hasData()) {
			result = {
				severity: MessageSeverity.INFO,
				label: "APPOINTMENTS.EMPTY_UPCOMING",
			};
		}
		return result;
	};

	return (
		<div className="appointment-list">
			{apptsUpcomingQuery.isLoading || apptsUpcomingQuery.isError || !hasData() ? (
				<UiMessage
					severity={setMessage().severity}
					label={setMessage().label}
				/>
			) : (
				apptsUpcomingQuery.data
					.filter((x) => new Date(x.datetime).getTime() >= new Date().getTime())
					.sort((a, b) => new Date(a.datetime).getTime() - new Date(b.datetime).getTime())
					.map((x) => (
						<div
							key={x.id}
							className="appointment"
						>
							<div className="appointment__info">
								<span className="appointment__info__type">
									{t(`ENUMS.APPOINTMENTS_TYPE.${x.type}`)}
								</span>
								<span className="appointment__info__duration">
									{`(${t(
										AppointmentsService.templateDuration(
											x.type,
											apptsTypesQuery.data ?? [],
											false
										)
									)})`}
								</span>
							</div>
							<div className="appointment__date">
								{AppointmentsService.templateDatetime(x.datetime, {
									weekday: "long",
									day: "2-digit",
									month: "long",
									year: "numeric",
									hour: "2-digit",
									minute: "2-digit",
									timeZoneName: "shortGeneric",
								})}
							</div>
						</div>
					))
			)}
		</div>
	);
};
export default UpcomingAppointments;
